/* eslint-disable max-len */
import React, { useEffect } from 'react';

import { tns } from 'tiny-slider/src/tiny-slider';
import img1 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-1-380.png';
import img2 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-2-380.png';
import img3 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-3-380.png';
import img4 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-4-380.png';
import img5 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-5-380.png';
import img6 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-6-380.png';
import img7 from '../../static/images/section5-afficher/affiches/min/Affiches-BRIDGE-72ppp-7-380.png';
import enfant from '../../static/images/section5-afficher/enfant-photographe.png';

export const Section5Afficher = ({ setImgModalOpen, setImgModalSrc }) => {
  const openModal = (src) => () => {
    setImgModalOpen(true);
    setImgModalSrc(src);
  };
  useEffect(() => {
    // code to run after render goes here
    tns({
      container: '#responsive',
      items: 2,
      slideBy: 1,
      speed: 1000,
      autoplay: true,
      // controls: false,
      responsive: {
        350: {
          items: 2,
          gutter: 30,
          // controls: true,
          edgePadding: 30,
        },
        500: {
          items: 3,
          gutter: 30,
        },
        900: {
          items: 3,
          gutter: 30,
        },

      },
      swipeAngle: false,

    });
  }, []);

  return (
    <section id="section5-afficher" className="w-10/12 m-auto flex flex-col md:flex-row">
      <div className="w-full md:w-3/4">
        <h2>Afficher...</h2>
        <div className="carreText">
          <p>
            Initiation à la photographie, mise en mots et en images des expériences et opinions sur la VBG, pour développer des affiches de sensibilisation.
            <br />
            Attention&nbsp;: Les résultats, non censurés et témoignant de la réalité des enfants et de leur exposition à la violence, peuvent heurter les sensibilités.
            {' '}
          </p>

        </div>
        <div id="responsive">
          <div>
            <img src={img1} alt="illustartion 1" onClick={openModal(img1)} />
          </div>
          <div>
            <img src={img2} alt="illustartion 2" onClick={openModal(img2)} />
          </div>
          <div>
            <img src={img3} alt="illustartion 3" onClick={openModal(img3)} />
          </div>
          <div>
            <img src={img4} alt="illustartion 4" onClick={openModal(img4)} />
          </div>
          <div>
            <img src={img5} alt="illustartion 5" onClick={openModal(img5)} />
          </div>
          <div>
            <img src={img6} alt="illustartion 6" onClick={openModal(img6)} />
          </div>
          <div>
            <img src={img7} alt="illustartion 7" onClick={openModal(img7)} />
          </div>
        </div>
      </div>
      <div className="w-full md:w-1/4">
        <img src={enfant} />
      </div>

    </section>
  );
};
